import { render, staticRenderFns } from "./detailsFcl.vue?vue&type=template&id=342cd668&scoped=true"
import script from "./detailsFcl.vue?vue&type=script&lang=js"
export * from "./detailsFcl.vue?vue&type=script&lang=js"
import style0 from "./detailsFcl.vue?vue&type=style&index=0&id=342cd668&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342cd668",
  null
  
)

export default component.exports